import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectsRedirectRoute: InvariantJiraRoute = {
	name: 'projects-redirect',
	path: '/projects/:projectKey',
	query: ['selectedItem!=(.+)'],
	exact: true,
};
